import { createSelector } from 'reselect';

const selectGlobalBranches = (state: any) => state.globalBranches;


export const selectGlobalBranchesCurrentItem = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.current);

export const selectGlobalBranchesListItems = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.list);

export const selectGlobalBranchesItemById = (itemId: any) =>
    createSelector(selectGlobalBranchesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalBranchesQueryItems = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.query);

export const selectGlobalBranchesCreatedItem = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.create);

export const selectGlobalBranchesUpdatedItem = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.update);

export const selectGlobalBranchesReadItem = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.read);

export const selectGlobalBranchesDeletedItem = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.delete);

export const selectGlobalBranchesSearchedItems = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.search);

export const selectGlobalBranchesItemsCount = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.count);

export const selectGlobalBranchesItemsFilter = createSelector([selectGlobalBranches], (globalBranches) => globalBranches.filter);